import { Link } from 'react-router-dom';

const QUICK_LINKS: { label: string; href: string }[] = [
  { label: 'About Us', href: '/#about' },
  { label: 'Services', href: '/#services' },
  { label: 'FAQ', href: '/#faq' },
  { label: 'Contact', href: '/contact' },
];

export function FooterNav() {
  return (
    <nav className="flex flex-col gap-3 items-start" aria-label="Quick links">
      {QUICK_LINKS.map(({ label, href }) => (
        <Link
          key={label}
          to={href}
          onClick={() => {
            if (!href.includes('#')) window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          className="group text-sm text-gray-300 hover:text-white active:text-white transition-colors duration-200 inline-flex items-center gap-2 w-fit min-h-[44px] py-2 -my-1 justify-start focus:outline-none focus:ring-0"
        >
          <span className="w-1.5 h-1.5 bg-blue-400 rounded-full opacity-0 group-hover:opacity-100 group-active:opacity-100 transition-opacity" aria-hidden />
          {label}
        </Link>
      ))}
    </nav>
  );
}
